const filterData = [
  {
    name: 'DistinctiveTitle',
    title: 'TITLE',
    type: 'text',
  },
  {
    name: 'AFM',
    title: 'TAXNUMBER',
    type: 'text',
  },
  {
    name: 'RegionID',
    optionsProp: 'regions',
    placeholder: ['DATAGRID_CHOOSE', 'REGION'],
    title: 'REGION',
    type: 'dropdown',
  },
];

export { filterData };
